import React, { ReactNode } from "react";
import styled from "styled-components";

const TabsContainer = styled.div`
    display: flex;
`;

interface TabsProps {
    readonly children: ReactNode[];
    readonly className?: string;
}
export default function Tabs(props: TabsProps) {
    return <TabsContainer className={props.className}>{props.children}</TabsContainer>;
}
